'use client'

import React from 'react'
import { cn } from '@/utilities/ui'

export const Separator: React.FC<{
  color: 'rock-2' | 'rock-1'
  thickness?: 1 | 2
  className?: string
}> = ({ color, className, thickness = 2 }) => {
  return (
    <div
      className={cn(
        'border-b',
        thickness === 1 && 'border-b-1',
        thickness === 2 && 'border-b-2',
        color === 'rock-2' && 'border-rock-2',
        color === 'rock-1' && 'border-rock-1',
        className,
      )}
    />
  )
}
